export default __webpack_public_path__ + "slices/main/assets/public/media/toaster-illustration.7e9085a95d9a5cd6a56cdcb1ef690e93.png";